<template>
  <div>
    <div class="mt-8">
      <h2 class="text-gray-500 text-xs font-medium uppercase tracking-wide">Accounts</h2>
      <div class="mt-2">
        <BaseFormInput
          v-model="searchQuery"
          :disabled="disabled"
          placeholder="Search"
          @change="searchAccounts"
        />
        <div class="flow-root mt-6">
          <ul class="-my-5 divide-y divide-gray-200">
            <li v-for="account in accounts" :key="account.id" class="py-4">
              <AccountOptionListItem
                :account="account"
                :is-linked="isLinked(account)"
                :disabled="disabled"
                :on-link-account="handleLinkAccount"
              />
            </li>
          </ul>
        </div>
        <div v-show="hasMore" class="mt-6">
          <button
            type="button"
            class="w-full flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            :disabled="disabled || !hasMore"
            @click="loadMore"
          >
            Load more
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { facebookPageAccountsClient } from '@/api/clients/admin';
import AccountOptionListItem from './AccountOptionListItem.vue';

export default {
  components: {
    AccountOptionListItem,
  },
  props: {
    pageId: {
      type: [String, Number],
      required: true,
    },
    linkedAccounts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      accountIds: [],
      searchQuery: '',
      disabled: false,
    };
  },
  computed: {
    accounts() {
      return this.accountIds.map((id) => this.$store.state.entities.accounts.byId[id]);
    },
    meta() {
      return this.$store.state.ui.accounts.meta;
    },
    hasMore() {
      const { current_page: current = 0, last_page: last = 0 } = this.meta || {};
      return current < last;
    },
  },
  created() {
    this.loadAccounts();
  },
  destroyed() {
    this.$store.commit('ui/accounts/setLinks', null);
    this.$store.commit('ui/accounts/setMeta', null);
    this.$store.commit('ui/accounts/setIds', []);
  },
  methods: {
    setDisabled(disabled) {
      this.disabled = disabled;
    },
    isLinked(account) {
      return this.linkedAccounts.some((linkedAccount) => linkedAccount.id === account.id);
    },
    async loadAccounts(queryParams = {}) {
      try {
        const { ids } = await this.$store.dispatch('ui/accounts/getAccounts', { queryParams });
        this.accountIds = [...new Set([...this.accountIds, ...ids])];
      } catch (error) {
        // something went wrong
      }
    },
    loadMore() {
      if (!this.hasMore) {
        return;
      }

      this.loadAccounts({
        page: this.meta.current_page + 1,
        filter: {
          name: this.searchQuery,
        },
      });
    },
    searchAccounts(name) {
      this.accountIds = [];

      this.loadAccounts({
        filter: {
          name,
        },
      });
    },
    handleLinkAccount(account) {
      this.disabled = true;
      return facebookPageAccountsClient
        .store(this.pageId, {
          account_id: account.id,
        })
        .then(() => {
          this.$emit('changed');
          return Promise.resolve();
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};
</script>
